import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Controller } from "react-hook-form";

const useStyles = makeStyles({
  input: {
    padding: "0px",
  },
  textFieldContainer: {
    backgroundColor: "#161616",
    marginTop: "0px",
    borderTopLeftRadius: "4px",
    borderTopRightRadius: "4px",
    borderBottom: "1px solid #757575",
    paddingTop: "16.5px",

    "& .MuiFormControl-root": {
      margin: "0 !important",
    },

    "& .MuiSelect-nativeInput": {
      height: "40px",
      padding: "8px 16px",
    },

    "& .MuiSelect-select": {
      background: "transparent !important",
      color: "#fff !important",
      textAlign: "left",
      fontSize: "16px",
      lineHeight: "24px",
      fontWeight: 400,
      padding: "8.5px 14px 8px 14px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "& .MuiFormLabel-root": {
      color: "#757575",
    },
    "& .MuiSvgIcon-root": {
      fill: "#757575",
      fontSize: "16px",
      right: "16px",
      top: "5px",
    },
  },
});

export default function FormSelectFieldDark(props) {
  const {
    control,
    name,
    label,
    size = "medium",
    variant = "outlined",
    fullWidth = true,
    autoFocus = false,
    style = {},
    onChange,
    onBlur,
    type = "",
    inputProps = {},
    options,
    // margin,
    formStyle,
    labelStyle = {},
    ...rest
  } = props;

  const classes = useStyles();

  return (
    <div className={classes.textFieldContainer} data-testid={`${name}-select-field`}>
      <FormControl fullWidth style={{ ...(formStyle || { margin: "4px" }) }}>
        <InputLabel style={labelStyle} id={`select-label-${name}`}>
          {label}
        </InputLabel>
        <Controller
          name={name}
          control={control}
          render={({ field, fieldState }) => {
            const { invalid, isDirty, isTouched } = fieldState;

            return (
              <Select
                labelId={`select-label-${name}`}
                name={field.name}
                ref={field.ref}
                className={classes.input}
                fullWidth={fullWidth}
                autoFocus={autoFocus}
                type={type}
                label={label}
                margin="none"
                size={size}
                variant={variant}
                style={style}
                error={(isDirty || isTouched) && invalid}
                onChange={(e) => {
                  if (onChange) {
                    onChange(e);
                  }
                  field.onChange(e);
                }}
                onBlur={(e) => {
                  if (onBlur) {
                    onBlur(e);
                  }
                  field.onBlur();
                }}
                inputProps={inputProps}
                {...rest}
              >
                {options.map((option, index) => (
                  <MenuItem
                    id={`menu-item-${index}`}
                    key={option.value || option}
                    classes={option.classes}
                    value={option}
                  >
                    {option.name || option}
                  </MenuItem>
                ))}
              </Select>
            );
          }}
        />
      </FormControl>
    </div>
  );
}
